'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  var requireLogin = function requireLogin(nextState, replace, cb) {
    function checkAuth() {
      var _store$getState = store.getState(),
          user = _store$getState.auth.user;

      if (!user) {
        // oops, not logged in, so can't be here!
        replace('/');
      }
      cb();
    }

    if (!(0, _auth.isLoaded)(store.getState())) {
      store.dispatch((0, _auth.load)()).then(checkAuth, checkAuth);
    } else {
      checkAuth();
    }
  };

  var attemptAuthLoad = function attemptAuthLoad(nextState, replace, cb) {
    // Immediately execute callback to not halt loading
    cb();

    if (!(0, _auth.isLoaded)(store.getState())) {
      store.dispatch((0, _auth.load)());
    }
  };

  /**
   * Please keep routes in alphabetical order
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/' },
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _containers.App },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Login, onEnter: attemptAuthLoad }),
      _react2.default.createElement(
        _reactRouter.Route,
        { onEnter: requireLogin },
        _react2.default.createElement(_reactRouter.Route, { path: 'dashboard', component: _containers.Dashboard }),
        _react2.default.createElement(_reactRouter.Route, { path: 'loginSuccess', component: _containers.LoginSuccess }),
        _react2.default.createElement(_reactRouter.Route, { path: 'search', component: _containers.Search }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'deviceDetailDashboard/:id',
          component: _containers.DeviceDetailDashboard
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'deviceDetailDashboard/:id/recording/:recId',
          component: _containers.DeviceDetailDashboard
        })
      ),
      _react2.default.createElement(_reactRouter.Route, { path: 'about', component: _containers.About, onEnter: attemptAuthLoad }),
      _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _containers.Login, onEnter: attemptAuthLoad })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'zendesk', component: _containers.Zendesk, onEnter: attemptAuthLoad }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/routes.js
 ** module id = 1405
 ** module chunks = 0
 **/